function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

var _dec, _class, _class2, _temp;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { Brick } from "zengular";
import twig from "./zengular-notification.twig";
import "./zengular-notification.scss";
import messageTemplate from "./zengular-notification-message.twig";
var ZengularNotification = (_dec = Brick.register('z-notification', twig), _dec(_class = (_temp = _class2 = /*#__PURE__*/function (_Brick) {
  _inherits(ZengularNotification, _Brick);

  var _super = _createSuper(ZengularNotification);

  function ZengularNotification() {
    _classCallCheck(this, ZengularNotification);

    return _super.apply(this, arguments);
  }

  _createClass(ZengularNotification, [{
    key: "onInitialize",
    value: function onInitialize() {
      this.constructor.brick = this;
    }
  }, {
    key: "show",
    value: function show(style, icon, message, timeout) {
      var _this = this;

      return new Promise(function (resolve) {
        var data = {
          style: style,
          icon: icon,
          message: message
        };
        var template = document.createElement('template');
        template.innerHTML = messageTemplate(data);
        message = template.content.childNodes[0];
        message.querySelector('.close').addEventListener('click', function (event) {
          _this.hide(message);

          event.stopPropagation();
        });

        _this.root.appendChild(message);

        var height;

        _this.requestAnimationFrame().then(function () {
          height = message.offsetHeight;
          message.style.height = '0px';
        }).then(function () {
          return _this.requestAnimationFrame();
        }).then(function () {
          return message.style.height = height + 'px';
        }).then(function () {
          return _this.wait(300);
        }).then(function () {
          return message.classList.add('visible');
        });

        if (timeout !== 0) setTimeout(function () {
          return _this.hide(message);
        }, timeout * 1000);
        resolve(message);
      });
    }
  }, {
    key: "hide",
    value: function hide(node) {
      var _this2 = this;

      node.classList.remove('visible');
      this.wait(300).then(function () {
        return node.classList.add('mini');
      }).then(function () {
        return _this2.wait(300);
      }).then(function () {
        return node.remove();
      });
    }
  }], [{
    key: "show",
    value: function show(style, icon, message) {
      var timeout = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 4;
      return this.brick.show(style, icon, message, timeout);
    }
  }]);

  return ZengularNotification;
}(Brick), _defineProperty(_class2, "style", {
  primary: 'primary',
  success: 'success',
  info: 'info',
  warning: 'warning',
  danger: 'danger'
}), _temp)) || _class);
export { ZengularNotification as default };